import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentcolor",
      "fill-rule": "evenodd",
      d: "M53.515 55.998H10.483A2.48 2.48 0 0 1 8 53.514V10.486a2.485 2.485 0 0 1 2.484-2.488h11.032A2.484 2.484 0 0 0 24 5.514V2.486a2.485 2.485 0 0 0-2.484-2.488H2.483A2.485 2.485 0 0 0 0 2.486v59.028a2.48 2.48 0 0 0 2.484 2.484h59.032A2.48 2.48 0 0 0 64 61.514V42.482a2.484 2.484 0 0 0-2.484-2.484h-3.032A2.484 2.484 0 0 0 56 42.482v11.032a2.48 2.48 0 0 1-2.484 2.484M36 2.486v3.028a2.484 2.484 0 0 0 2.484 2.484h3.52c2.212 0 3.32 2.676 1.756 4.244l-14 14a2.48 2.48 0 0 0 0 3.512l4.484 4.488c.972.972 2.54.972 3.516 0l14-14c1.564-1.568 4.24-.456 4.24 1.756v3.516a2.484 2.484 0 0 0 2.484 2.484h3.032A2.484 2.484 0 0 0 64 25.514V2.486a2.485 2.485 0 0 0-2.484-2.488H38.483A2.485 2.485 0 0 0 36 2.486"
    }, null, -1)
  ]))]))
}
export default { render: render }